import { Suspense, lazy } from 'react';
import { MainAppMethods } from '../../App'
const Component = lazy(() => import("./AddressBan"));

function ListEditor(props: MainAppMethods) {
  return (
    <div>
      <Suspense fallback={<div>loading...</div>}>
        <Component getHeaders={props.getHeaders} />
      </Suspense>
    </div>);

}

export default ListEditor;



